import { formNames } from '@wkda/carlead-creation-form';
import { CarleadFieldsMap } from '../carleadFieldsMap';
import { leaveOnlyNumber } from '@wkda/funnel-utils';

/**
 * Mapping object that maps form names to their corresponding select item IDs or custom transformation functions.
 */
const DSBToSFMap = {
  [formNames.manufacturer]: selectItemId(formNames.manufacturer),
  [formNames.mainType]: selectItemId(formNames.mainType),
  [formNames.builtDate]: selectItemId(formNames.builtDate),
  [formNames.bodyType]: selectItemId(formNames.bodyType),
  [formNames.mainTypeDetail]: selectItemId(formNames.mainTypeDetail),
  [formNames.mainTypeSub]: selectItemId(formNames.mainTypeSub),
  [formNames.mileage]: selectItemId(formNames.mileage),
  [formNames.fuelType]: selectItemId(formNames.fuelType),
  [formNames.horsePower]: selectItemId(formNames.horsePower),
  [formNames.gearType]: selectItemId(formNames.gearType),
  [formNames.doorCount]: selectItemId(formNames.doorCount),
  [formNames.location]: d => d?.zipCode?.selected?.label && d?.zipCode?.selected?.value ? {
    label: d.zipCode.selected.label,
    lat: d.zipCode.selected.value.lat,
    lng: d.zipCode.selected.value.lng
  } : null,
  [formNames.email]: d => {
    return d?.email?.selected || '';
  },
  [formNames.licensePlate]: d => {
    return d?.licensePlate?.value;
  },
  [formNames.mobile]: d => {
    return d?.mobile?.value;
  },
  [formNames.firstName]: d => {
    return d?.firstName?.value;
  },
  [formNames.lastName]: d => {
    return d?.lastName?.value;
  }
};
export function mapFromDSB(formData, questionnaireData, config) {
  return {
    ...mapFromDSBForm(formData, config),
    ...mapFromDSBQuestionnaire(questionnaireData)
  };
}
function mapFromDSBForm(data, config) {
  let _map = DSBToSFMap;
  if (config.exactMileage) {
    _map = {
      ..._map,
      [formNames.mileage]: d => d?.stepCompoundForm?.exactMileage?.value ? leaveOnlyNumber(d?.stepCompoundForm?.exactMileage?.value) : ''
    };
  }
  return Object.entries(_map).reduce((acc, _ref) => {
    let [key, fn] = _ref;
    const mapped = fn(data);
    return {
      ...acc,
      [key]: mapped
    };
  }, {});
}
function selectItemId(fieldName) {
  return function _selectItemId(d) {
    const value = CarleadFieldsMap.toDSB(fieldName);
    return value === undefined || value === 'email' || value === 'licensePlate' || value === 'mobile' || value === 'firstName' || value === 'lastName' || value === 'zipCode' ? '' : value === 'exactMileage' ? itemValueSelector(d?.stepCompoundForm?.[value]) : itemIdSelector(d?.stepCompoundForm?.[value]);
  };
}
function itemIdSelector(d) {
  return d?.selectedId || '';
}
function itemValueSelector(d) {
  return d?.value || '';
}
function mapFromDSBQuestionnaire(data) {
  return data?.flexibleQuestionnaire?.customerSurvey?.questions?.reduce((questionnaire, question) => ({
    ...questionnaire,
    [question.questionId]: question.answerId
  }), {});
}